<div *ngIf="!loadingPlacers" class="placer-selector">
  <mat-form-field appearance="outline">
    <mat-select
      matInput
      placeholder="Installateur"
      [(ngModel)]="selectedPlacer"
      (ngModelChange)="selectedPlacerChange()"
      name="placerSelector"
      [compareWith]="compareEntities"
    >
      <mat-option
        *ngFor="let option of placerOptions; trackBy: trackById"
        [value]="option"
        >{{
          option.user?.firstName | personName: option.user?.lastName
        }}</mat-option
      >
      <mat-option [value]="null">
        Geen
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div *ngIf="loadingSubProjects" class="placement-loader-overlay">
  <div style="margin-top: 200px; align-self: center">
    <mat-spinner
      style="margin:auto;"
      color="primary"
      diameter="75"
    ></mat-spinner>
  </div>
</div>

<div class="sub-project-grid">
  <div
    *ngFor="let subProjectDisplay of renderedStream | async; trackBy: trackById"
    class="sub-project-grid-item"
  >
    <most-recent-placement-item
      [subProjectDisplay]="subProjectDisplay"
    ></most-recent-placement-item>
  </div>
</div>
